import createHistory from 'history/createBrowserHistory';
const history = createHistory();
history.listen((location) => {
  // console.log('urlPath: ', location.pathname); // /home
});
export default history;



// WEBPACK FOOTER //
// ./src/history.js